import * as React from "react";
import cx from "classcat";

type ClassName = string | undefined;
type Overrides = {
  style?: ClassName | Array<ClassName | boolean>;
};

export const Text = React.forwardRef<
  HTMLDivElement,
  Omit<Omit<React.ComponentProps<"div">, "className">, "style"> & Overrides
>((props, ref) => {
  const { children, style, ...rest } = props;
  const className = Array.isArray(style) ? cx(style) : style;
  return (
    <div ref={ref} className={className} {...rest}>
      {children}
    </div>
  );
});
